import { render, staticRenderFns } from "./lote1.vue?vue&type=template&id=263e1dcd&"
import script from "./lote1.vue?vue&type=script&lang=js&"
export * from "./lote1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports